import { addNewRelicPageAction } from 'ddc-new-relic';
/**
 *
 * @param {object} win - The window object
 * @returns A promise that will resolve until data for vehicles array has arrived.
 */

const vehicleHasLengthPromise = (win) =>
	new Promise((resolve) => {
		const interval = setInterval(() => {
			if (win.DDC?.dataLayer?.vehicles?.length) {
				clearInterval(interval);
				resolve('datalayer');
			}
		}, 10);
	});

const vehicleAPIPromise = async (win) => {
	const API = await win.DDC.APILoader.create(
		'ws-tagging waiting for vehicle'
	);
	return new Promise((resolve) => {
		API.subscribe('vehicle-data-updated-v1', () => {
			resolve('api');
		});
	});
};

const safeTimeoutPromise = (timeout = 5000) =>
	new Promise((resolve) => {
		setTimeout(() => {
			resolve('timeout');
		}, timeout);
	});

const vehicleDataUpdated = (win, timeout) => {
	return new Promise((resolve) => {
		Promise.race([
			vehicleHasLengthPromise(win),
			vehicleAPIPromise(win),
			safeTimeoutPromise(timeout)
		]).then((v) => {
			if (v === 'timeout') {
				addNewRelicPageAction('wsTaggingVehicleData', {
					wsTaggingError: 'vehicleDataDidntUpdate',
					wsTaggingEnable: true
				});
			}
			resolve(v);
		});
	});
};

export default vehicleDataUpdated;
